'use client';

import type { FragmentType } from '@packages/gql/generated/shopping';
import { getFragmentData } from '@packages/gql/generated/shopping';
import { SimilarProductsRecommendationsFragmentDoc } from '@packages/gql/generated/shopping/SimilarProductsRecommendationsFragmentDoc';
import { SimilarProductsRecoSlider } from '@packages/recommendations';
import { useIntl } from 'react-intl';
import { similarProductsFallbackHeadline } from './messages';

/* GraphQL */ `
  fragment SimilarProductsRecommendations on Product {
    hasSeries
    promotion
    orderNumber
  }
`;

export type SimilarProductsProps = {
  /**
   * The data from the product query needed for the `SimilarProductsRecoSlider` comnponent.
   */
  data: FragmentType<typeof SimilarProductsRecommendationsFragmentDoc>;
};

/**
 * This component is a wrapper for the `SimilarProductsRecoSlider` component.
 * It encapsulates the data from the product query needed for the `SimilarProductsRecoSlider` component and passes correct props.
 */
export const SimilarProductsRecommendations = ({ data }: SimilarProductsProps) => {
  const { hasSeries, orderNumber, promotion } = getFragmentData(
    SimilarProductsRecommendationsFragmentDoc,
    data,
  );
  const { formatMessage } = useIntl();

  return (
    <SimilarProductsRecoSlider
      productId={`${orderNumber}${promotion}`}
      elementIndex={hasSeries ? 3 : 2}
      fetchOnThreshold
      pageTemplate="detailview"
      title={formatMessage(similarProductsFallbackHeadline)}
      key={`${orderNumber}3`}
    />
  );
};
